export default {
  GOAL_DEFINITION_STEP_REPOSITORY: Symbol.for('GOAL_DEFINITION_STEP_REPOSITORY'),
  UPDATE_GOAL_DEFINITION_STEP_COMMAND: Symbol.for('UPDATE_GOAL_DEFINITION_STEP_COMMAND'),
  GET_GOAL_DEFINITION_STEP_QUERY: Symbol.for('GET_GOAL_DEFINITION_STEP_QUERY'),
  GOAL_DEFINITION_STEP_STATE_MANAGER: Symbol.for('GOAL_DEFINITION_STEP_STATE_MANAGER'),
};
